import qs from 'query-string';
import React, { Fragment } from 'react';
import { ArcaChangePassword } from '../../code/ArcaChangePassword';
import { ArcaField } from '../../code/ArcaField';
import { ArcaHttpClientLogin } from '../../code/ArcaHttpClientLogin';
import { ArcaHttpSystem } from '../../code/ArcaHttpSystem';
import { ArcaPageFieldState } from '../../code/ArcaPageFieldState';
import { ArcaRedirect } from '../../code/ArcaRedirect';
import { ArcaSecurity } from '../../code/ArcaSecurity';
import { ArcaLink } from '../controls/Fields/ArcaLink';
import { InputFieldArray } from '../controls/Fields/InputFieldArray';
import { LoginPanel } from '../controls/Security/LoginPanel';
import { StatusBar } from '../controls/StatusBar';
import { ArcaComponent } from './ArcaComponent';

export class SetAccount extends ArcaComponent {

    constructor(props) {
        super(props);

        const values = qs.parse(this.props.location.search);
        let registrationId = values.id

        ArcaHttpSystem.IsLogging = false;
        ArcaHttpSystem.Log(registrationId)

        if (registrationId !== undefined && registrationId !== null) {
            const data = new ArcaChangePassword()
            this.state = {
                registrationId,
                data,
                formState: this.buildFields(data),
                formValid: false,
                message: null,
                isError: false,
                passwordSet: false
            };
        }
        else {
            ArcaRedirect.Push('/Home');
        }
    }

    render() {
        let { formState, formValid, message, isError, passwordSet } = this.state
        let pass1 = formState.GetField("NewPassword1").Value
        let pass2 = formState.GetField("NewPassword2").Value

        return (
            <div>

                <h1>Registration</h1>

                {!passwordSet
                    ? <Fragment>
                        <p>Please create your new password</p>

                        <InputFieldArray
                            formState={formState}
                            onUpdate={this.onUpdate.bind(this)} />

                        {pass1 !== pass2
                            ? 'Your passwords are different'
                            : 'Your passwords are the same'
                        }
                    </Fragment>
                    : null}

                <StatusBar message={message} isError={isError} />

                {passwordSet
                    ? <LoginPanel onLogon={this.onLogin.bind(this)} />
                    : <ArcaLink text='Save password' onClick={() => this.setAccount(this.state.registrationId, pass1)} width='100%' disabled={!formValid} />
                }


            </div >
        );
    }

    async onLogin() {
        ArcaRedirect.Push('/Home');
    }

    async setAccount(registrationId, password) {
        await ArcaHttpClientLogin.SetAccountAsync(
            registrationId,
            password,
            (() => this.setState({ message: 'Your password has been set correctly', isError: false, passwordSet: true })),
            (() => this.setState({ message: 'Password reset failed', isError: false }))
        )

    }

    onUpdate(value, isValid, fieldName) {

        let { formState } = this.state;

        formState.GetField(fieldName).Value = value;
        formState.GetField(fieldName).IsValid = isValid;

        const formValid = 
            formState.IsValid
            && (formState.GetField('NewPassword1').Value === formState.GetField('NewPassword2').Value)

        this.setState({
            formValid: formValid
        });
    }

    buildFields(data) {
        var formState = new ArcaPageFieldState();
        formState.AddField(new ArcaField("Your password", "NewPassword1", data.NewPassword1, true, true, 'text', 'password'));
        formState.AddField(new ArcaField("Your password again", "NewPassword2", data.NewPassword2, true, true, 'text', 'password'));

        return formState;
    }
}
